// extracted by mini-css-extract-plugin
export var askAiIcon = "_p5-k";
export var category = "_p5-a";
export var categoryHeader = "_p5-f";
export var container = "_p5-0";
export var group = "_p5-b";
export var groupItems = "_p5-g";
export var groupSeparator = "_p5-l";
export var highlight = "_p5-8";
export var loading = "_p5-1";
export var noResults = "_p5-3";
export var placeholder = "_p5-2";
export var resultContent = "_p5-5";
export var resultIcon = "_p5-d";
export var resultItem = "_p5-h";
export var resultMeta = "_p5-9";
export var resultSubtitle = "_p5-7";
export var resultSuffix = "_p5-j";
export var resultTitle = "_p5-6";
export var resultsList = "_p5-4";
export var searchGroup = "_p5-e";
export var selected = "_p5-i";
export var subgroup = "_p5-c";